import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-gatewee-generic-modal',
  templateUrl: './gatewee-generic-modal.component.html',
  standalone: false,
})
export class GateweeGenericModalComponent {
  @Input() title = 'Confirmação';
  @Input() message = '';
  @Input() confirmLabel = 'Confirmar';
  @Input() cancelLabel = 'Cancelar';
  @Input() showFooter = true;

  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  constructor(public activeModal: NgbActiveModal) {}

  onConfirm(): void {
    this.confirmed.emit();
    this.activeModal.close(true);
  }

  onCancel(): void {
    this.cancelled.emit();
    this.activeModal.dismiss(false);
  }
}
